import { useMemo } from 'react';
import { PhoneCallsQueries } from '@frontend/api-phone-calls';
import { useTeamPresenceLocationIds } from '@frontend/calls-v2';
import { useTranslation } from '@frontend/i18n';
import { useHasPhoneSystemAccess } from '@frontend/phone-config';
import { useAppScopeStore } from '@frontend/scope';
import { createNavItem, createSubNavItems } from '../nav-item-utils';
import { featureDefinition as callsFeatureDefinition } from './feature-definitions';

export const useCallsNavItem = () => {
  const { t } = useTranslation('primaryNav');
  const { selectedLocationIds } = useAppScopeStore();
  const hasPhoneSystemAccess = useHasPhoneSystemAccess({ locationIds: selectedLocationIds });
  const teamPresenceLocationIds = useTeamPresenceLocationIds();
  const hasTeamPresenceAccess = teamPresenceLocationIds.length > 0;
  const voicemailsUnreadCount = PhoneCallsQueries.useVoicemailsUnreadCount();
  const callsItems = callsFeatureDefinition.items;

  const subNavItems = useMemo(() => {
    const items = [
      {
        ...callsItems['/call-history'],
        relativePath: '/call-history',
        label: t('Call History'),
        altSearchLabel: t('Recent Calls'),
      },
      {
        ...callsItems['/voicemails'],
        relativePath: '/voicemails',
        label: t('Voicemails'),
        count: voicemailsUnreadCount,
      },
      {
        ...callsItems['/call-queue-stats'],
        relativePath: '/call-queue-stats',
        label: t('Call Queue Data'),
      },
      {
        ...callsItems['/team-presence'],
        relativePath: '/team-presence',
        label: t('Team Status'),
        show: hasTeamPresenceAccess,
      },
    ];

    return createSubNavItems(items);
  }, [callsItems, t, voicemailsUnreadCount, hasTeamPresenceAccess]);

  return useMemo(
    () =>
      createNavItem('calls', {
        hasCount: !!voicemailsUnreadCount,
        iconName: 'phone',
        show: hasPhoneSystemAccess,
        root: '/calls',
        label: t('Calls'),
        subNavItems,
        settings: { path: '/phone/main', label: '' },
      }),
    [t, voicemailsUnreadCount, hasPhoneSystemAccess, subNavItems]
  );
};
